import Page from '../../layout/Page';
import styled from '@emotion/styled';
import First from './first/first';
// import Fifth from './fifth';
import Sixth from './sixth';
import Eigth from './eigth';
import ReactPixel, { track } from 'react-facebook-pixel';
import { useCallback, useEffect, useRef, useState } from 'react';
import Hero from './hero';
import { useNavigate } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import EventModal from "./EventModal";
import Third from './third';
import Event from './event';
import Card from './card';
import { trackKakaoPageView } from 'hooks/util/useKakaoPixel';
import ImageEventModal, { ClickArea } from './modal/image_event_modal'; // 경로는 실제 위치에 맞춰 수정



const Elem:React.FC<any> = () =>{
  const [hasScrolled50, setHasScrolled50] = useState(false);
  const [hasScrolled70, setHasScrolled70] = useState(false);
  const [hasScrolled90, setHasScrolled90] = useState(false);
  const [ isButtonFixed, setIsButtonFixed ] = useState(true);
  const [ showModal, setShowModal ] = useState(false);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const topButtonPosition = 100;
  const buttonTopPosition = 100000;
  
  // const handleGoToLoginButton = () => {
  //   ReactPixel.fbq('track', 'StartTrial', {
  //     "currency": "KRW",
  //     "value" : 0.00,
  //     "predicted_ltv" : 10000,
  //     "event_type" : "bottom"
  //   });
    
  //   // window.location.href = "/login"
  //   window.location.href = "/subscribe"
  // }

  // const closeModal = () => {
  //   if (showModal) {
  //     setShowModal(false)
  //   }
  // };
  
  // useEffect(() => {
  //   setShowModal(true)
  // }, [])



  const navigate = useNavigate();
  // const handleMoreSubscribe = () => {
  //   ReactPixel.fbq('track', 'StartTrial', {
  //     "currency": "KRW",
  //     "value" : 0.00,
  //     "predicted_ltv" : 10000,
  //     "event_type" : "top"
  //   });
  //   navigate('/login');
  //   // window.location.href = "/login"
  // }

//   useEffect(() => {
//   // 최초 진입 시 1회만 실행
//   // ReactPixel.track('Purchase', {
//   //   value: 10000,   // 숫자형 (콤마 제거)
//   //   currency: 'KRW',
//   // });

//   ReactPixel.track('Lead', {
//     value: '10,000.0', // 구매 금액
//     currency: 'KRW',
//   });

// }, []); // 빈 배열: mount 시 딱 한 번만
  

  // useEffect(()=> {
  //   trackKakaoPageView(process.env.REACT_APP_KAKAO_PIXEL_ID!,'home')
  // })


  useEffect(() => {

    const handleScroll = async () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // scroll50%일때 이벤트 보내기
      if (scrollPosition > documentHeight * 0.5 && !hasScrolled50) {
        ReactPixel.fbq('trackCustom', 'HalfwayPercentScrolled', {
          name: "HalfwayPercentScrolled"
        });
        setHasScrolled50(true);
      };

      if (scrollPosition > documentHeight * 0.7 && !hasScrolled70) {
        ReactPixel.fbq('trackCustom', 'SeventyPercentScrolled', {
          name: "SeventyPercentScrolled"
        });
        setHasScrolled70(true);
      };
      

      if (scrollPosition > documentHeight * 0.9 && !hasScrolled90) {
        ReactPixel.fbq('trackCustom', 'NinetyPercentScrolled', {
          name: "NinetyPercentScrolled"
        });
        setHasScrolled90(true);
      };

      // 버튼 고정 위치 처리
      if (topButtonPosition > scrollPosition) {
        setIsButtonFixed(false);
      } else if (topButtonPosition < scrollPosition && scrollPosition < buttonTopPosition) {
        setIsButtonFixed(true);
      } else {
        setIsButtonFixed(false);
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }

  },[hasScrolled50, hasScrolled70 , hasScrolled90]);

//   // 열기
// const openModal = useCallback(() => {
//   setShowModal(true);
//   // 오픈 트래킹 (선택)
//   // ReactPixel.fbq('trackCustom', 'LandingModalOpened', { name: 'LandingModalOpened' });
// }, []);

// // 닫기
// const closeModal = useCallback(() => {
//   setShowModal(false);
//   // 닫기 트래킹 (선택)
//   // ReactPixel.fbq('trackCustom', 'LandingModalClosed', { name: 'LandingModalClosed' });
// }, []);

// // 최초 진입 시 1회 오픈 (필요시 조건 분기 가능)
// useEffect(() => {
//   openModal();
// }, [openModal]);


  // return (
  //   <>
  //     <Page disable={true}>
  //       <ContentsConatiner>
  //         <Body>
  //           <First />
  //           <Third />
  //           <Hero />
  //           <Event />
  //           <Eigth />
  //           <ImgContainer>
  //             <Img src="/images/klikkie/main/bottom.png"/>
  //           </ImgContainer>
  //           <ImgContainer>
  //             <Img src="/images/klikkie/main/help.png"/>
  //           </ImgContainer>
  //         </Body>
  //       </ContentsConatiner>
  //     </Page>
  //     {/* {showModal && <EventModal showModal={showModal} closeModal={closeModal} />} */}
  //   </>
  // )
  return (
    <>
      <Page disable={true}>
        <ContentsConatiner>
          <Body>
            {/* <First /> */}
            {/* <Third /> */}
            {/* <BannerContainer>
              [마감임박] 12개월 구독시 20% 할인 행사 중 (~2.9)
            </BannerContainer> */}
            <ImgContainer>
            <Img src='/images/klikkie/main/landingHeader.png'/>
            </ImgContainer>
            <Hero />
            <Card />
            {/* <Event /> */}
            <ImgContainer>
              <Img src="/images/klikkie/main/landingbottom.png"/>
            </ImgContainer>
            <Eigth />
            <ImgContainer>
              <Img src="/images/klikkie/main/help.png"/>
            </ImgContainer>
          </Body>
        </ContentsConatiner>
      </Page>
      {/* {showModal && <EventModal showModal={showModal} closeModal={closeModal} />} */}
      {/* {showModal && (
      <ImageEventModal
        onClose={closeModal}
        // onConfirm={handleGoSubscribe}
        imageSrc="/images/event/poster2.png"
        // imageSrc2x="/images/event/poster2.png"
        alt="포티페타 구독 프로모션"
        // clickAreas={modalAreas}            // ← 특정 영역만 클릭 처리(옵션)
        wholeImageClickable={false}        // ← 전체 이미지는 클릭 비활성화 (옵션)
        maxWidth={560}                     // ← 필요 시 사이즈 조정
      />
    )} */}

    {/* ✅ 모달
      {showModal && (
        <ImageEventModal
          onClose={closeModal}
          // onConfirm={handleGoSubscribe}
          imageSrc="/images/event/poster2.png"
          imageSrc2x="/images/event/poster2.png"
          alt="포티페타 구독 프로모션"
          // clickAreas={modalAreas}
          wholeImageClickable={false}
          containerSelector="#landing-root" // ← 이 컨테이너 폭에 맞춤
          maxWidthPx={960}                  // 컨테이너가 더 커도 여기까지만
          maxHeightVh={88}
        />
      )} */}
    </>
  )
};

export default Elem;

const BannerContainer = styled.div`
  width: 100%;
  height: 40px;
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 15px;
  font-weight: 600;
  font-family: 'Pretendard', sans-serif;
`;


const ContentsConatiner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Body = styled.div`
  /* width: 100%; */
  margin-top: 120px;
  display: flex;
  flex-direction: column;
`

const MiddleContainer = styled.div`
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  text-align: center;

  font-size: 30px;

  &.Bottom {
    justify-content: center;
  }
`;

const FirstTextContainer = styled.div`
  min-height: 246px;
  font-weight: bold;
  font-size: 16px;

  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  line-height: 1.5;
`;

const ImgContainer = styled.div`
  width: 100%;
`

const Img = styled.img`
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 600px;
  background-image: url("/images/klikkie/main/background.png");
  background-size: cover;
  justify-content: space-between;
`;

const TextContainer = styled.div`
  margin-top: 100px;
  width: 100%;
  min-height: 100px;
`

// const ImgContainer = styled.div`
//   width: 100%;
// `;

// const Img = styled.img`
//   width: 100%;
// `;

const BoldText = styled.div`  
  display: flex;
  /* flex-direction: column; */
  /* justify-content: center; */
  /* text-align: center;  */
  align-items: center;
  padding-left: 30px;
  font-weight: bold;
  font-size: 30px;
  line-height: 1.3;

  span {
    font-weight: bold;  
  }
`;

const SmallText = styled.div`
  font-size: 16px;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
`

// const CircularButtonWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
  
//   width: 90%;
//   height: 50px;

//   &.top {
//     margin: 0 auto 20px;
//   }

// `;

// const CircularButton = styled.button`
//   width: 100%;
//   height: 100%;
//   border-radius: 30px;
//   /* background-color: #e1a349; */
  
//   /* font-weight: bold; */
//   color: #fff;

//   &.top {
//     background-color: black;
//   }

//   &.bottom {
//     background-color: #18B2BB;
//   }

//   span {
//     font-weight: bold;
//   }
// `;

interface ButtonContainerProps {
  isFixed: boolean;
};

interface ButtonContainerProps {
  isFixed: boolean;
};

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #ede3cd;
`;

const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;


const CircularButtonWrapper = styled.div<ButtonContainerProps>`
  width: 90%;
  height: 50px;
  color: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #e1a349;
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
  bottom: ${({ isFixed }) => (isFixed ? '20px' : 'auto')};
  margin: ${({ isFixed }) => (isFixed ? '0' : '0 auto')};
  /* margin-bottom: 25px;
  margin-top: 50px; */
  margin: 50px auto 25px;
  animation: ${({ isFixed }) => (isFixed ? slideUp : 'none')} 0.5s ease-in-out;
  display: ${({ isFixed }) => (isFixed ? 'block' : 'none')};
  transition: all 0.5s ease-in-out;
  z-index: 999;
`;

const CircularButton = styled.button`
  width: 100%;
  height: 100%;
  font-weight: bold;
  /* background-color: #e1a349; */
  background-color: black;
  color: white;
  border-radius: 40px;
`;